import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "icon"]

  connect() {
    if (this.hasActiveFilters()) {
      this.expand()
    }
  }

  toggle() {
    this.panelTarget.classList.toggle("in")
    this.iconTarget.classList.toggle("fa-chevron-down")
    this.iconTarget.classList.toggle("fa-chevron-up")
  }

  // private

  hasActiveFilters() {
    const params = new URLSearchParams(window.location.search)
    for (const [key, value] of params) {
      if (key.startsWith("q[") && value && value !== "all") return true
    }
    return false
  }

  expand() {
    this.panelTarget.classList.add("in")
    this.iconTarget.classList.remove("fa-chevron-down")
    this.iconTarget.classList.add("fa-chevron-up")
  }
}
